window.BankReconciliation = {


    translations: {
        yes: Loc.g("Oui"),
        no: Loc.g("Non"),
        synchroTitle: Loc.g("Synchronisation de vos comptes bancaires"),
        synchroContent: Loc.g("Voulez-vous synchroniser vos comptes bancaires ?"),
        desynchroTitle: Loc.g("Désynchronisation"),
        desynchroContent: Loc.g("Voulez-vous désynchroniser votre compte bancaire avec Budget-Insight ? Cette action est irréversible"),
        searchDocuments: Loc.g("Faire une recherche de document"),
        backToSuggestions: Loc.g("Revenir aux suggestions"),
        genericErrorMsg: Loc.g("Problème lors de la validation de l‘opération. Veuillez vérifier vos informations."),
        exportBankJournal: Loc.g("Exporter votre Journal de banque"),
        generatingExport: Loc.g("Export en cours de traitement"),
        exportMessaage: Loc.g("Nous sommes en train de générer le fichier d'export.  Vous recevrez un email avec un lien de téléchargement lorsque le fichier sera prêt"),
        export: Loc.g("Exporter"),
        cancel: Loc.g("Annuler"),
        valid: Loc.g("Valider"),
    },
    seletectedTransactions: [],
    mapSelectedTransactionsByBankAccount: [],


    /**
     * Transactions list
     */
    prepareFilterForm: function () {
        var options = {
            data: {
                action: 'updateListing'
            },
            success: function (data) {
                var menuTransaction = $('ul.menu_transaction');

                // Force filter status
                $('#transactionsListing_filter_transactionStatus').val(data.filter.filter.transactionStatus);
                menuTransaction.find('> li a').addClass('btn-disabled');
                menuTransaction.find('> li a').attr('onclick', 'return false;');

                for (var index in data.status) {
                    menuTransaction.find('li#menu_transactionStatus_' + index).find('a').removeClass('btn-disabled');
                    menuTransaction.find('li#menu_transactionStatus_' + index).find('a').attr('onclick', "BankReconciliation.injectFilter('transactionsListing_filter_transactionStatus','" + index + "');");


                    if (data.status[index]['selected']) {
                        menuTransaction.find('> li a').removeClass('btn-primary').addClass('btn-default');
                        menuTransaction.find('li#menu_transactionStatus_' + index).find('a').removeClass('btn-default').addClass('btn-primary');
                    }
                }
                BankReconciliation.processFilterForm(data);
                BankReconciliation.prepareCheckedTransactionEvent();

            },
            dataType: "json"
        };

        MyForm.prepare("transactionsFilterForm", "bankreconciliation_transactions", options);
    },

    processFilterForm: function (data) {
        Listing.refresh("transactionsListing", data, data.transactions_metadatas);
    },

    injectFilter: function (filterName, filterValue) {
        if (filterName == "transactionsListing_filter_transactionStatus") {
            $("#transactionsListing_external_filter_transactionStatus ul li a").attr("class", "btn btn-default");
            $('#transactionStatus_' + filterValue).toggleClass("btn-default btn-primary");
        }
        else if (filterName == "transactionsListing_filter_bankAccountId") {
            $("#bank-accounts>li>div").removeClass("bl-4-blue").addClass("well-no-shadow");
            $('#bankAccountId_' + filterValue).toggleClass("well-no-shadow bl-4-blue")
        }

        filterName = '' + filterName;
        $('#' + filterName).val(filterValue);
        $('#' + filterName).change();
    },

    /**
     * Transaction view with multiples forms
     */

    init: function () {

        this.bindEvent();

        MyTabsV2.init($('.sellsyTabs'));

        BankReconciliation.prepareTransferActionsTransactionForm();
        BankReconciliation.prepareReconciliateAccForm();
        BankReconciliation.prepareSearchDocForm();
        BankReconciliation.prepareReconciliateDocForm();

    },

    bindEvent: function () {
        $(window).on("scroll", function () {

            var $well       = $(".js-recap-well");
            var $wellFixed  = $(".js-recap-well-hidden");
            var wellTop     = ($well.position().top) - 60;
            var windowTop   = $(document).scrollTop();

            if (windowTop > wellTop) {
                if (!$well.hasClass("opacity-0")) {
                    $well.addClass("opacity-0")
                    $wellFixed.addClass("opacity-1")
                    $wellFixed.removeClass("hidden")
                }
            }
            else {
                $well.removeClass("opacity-0");
                $wellFixed.removeClass("opacity-1");
                $wellFixed.addClass("hidden");
            }
        });
    },

    /**
     * Reconciliation form for accounting codes
     */

    prepareReconciliateAccForm: function () {
        var formID = "reconciliateAccountingCode";

        var options = {
            data: {
                action: 'reconciliateAccountingCode',
            },
            beforeSubmit: function () {
                MyFacture.startWait();
            },
            success: function (data) {
                var formIsOk = MyForm.processJson(data, formID);

                if (formIsOk) {
                    const reloadType = data.form.fields.find(field => field.fieldId == 'reloadType').value
                    if (reloadType == 'save') {
                        Utils.reload();
                    } else if (reloadType == 'save_and_redirect') {
                        Utils.relocate('./?_f=bankreconciliation_transactions');
                    }
                } else {
                    MyFacture.stopWait();
                }
            },
            dataType: "json"
        };

        MyForm.prepare(formID, "bankreconciliation_reconciliation", options);
        MyFacture.initEvent("#" + formID);

        // Total recap dynamic update
        $('.recacc_amount, .recacc_type').on('change', function () {
            BankReconciliation.updateRecTotals('acc');
        }).change();


    },

    /**
     * Generic function used for accounting, suggestions and search forms
     */
    updateRecTotals: function (context) {

        var formId = '';

        if ($("#resultSearchForm").is(":visible")) {
            formId = 'resultSearchForm';
        } else if ($("#suggestionForm").is(":visible")) {
            formId = 'suggestionForm';
        }

        var numberFormat = NumberFormat.loadFromInputs("numformat_");
        var amountToRec = Big(0);

        var recapDivSelector = '.recap_' + context;

        // Calculate total amount to reconciliate if multiple lines
        if (context == 'acc') {
            var transactionType = $('#transactionType').val();
            var prefix = 'recacc_';
            $('.' + prefix + 'amount').each(function () {
                var type_id = $(this).attr('id').replace("amount", "type");
                var type = $('#'+type_id).val();

                if(type != transactionType){
                    amountToRec = amountToRec.minus(NumberFormat.formatToFloat($(this).val(), numberFormat));
                } else {
                    amountToRec = amountToRec.plus(NumberFormat.formatToFloat($(this).val(), numberFormat));
                }
            });
        } else if (context == 'doc') {
            $('#' + formId).find('div.newPayment').find('input:checked').each(function () {
                var tmpAmount = NumberFormat.formatToFloat($(this).closest('div.newPayment').find('input.amountInput').val(), numberFormat);
                amountToRec = amountToRec.plus(tmpAmount);
            });
            $('#' + formId).find('input.paymentCheckbox:checked, input.deadlineCheckbox:checked').each(function () {
                var tmpAmount = new Big($(this).attr('data-amount'));
                amountToRec = amountToRec.plus(tmpAmount);
            });
        }

        // Update recap fields
        $(recapDivSelector).find('#recapAmountToReconciliate').val(amountToRec).change();
        $(recapDivSelector).find('#rawRecapAmountToReconciliate').val(amountToRec);

        var amountTransaction = new Big($('#rawRecapAmountTransaction').val());
        var amountAlreadyReconciled = new Big($('#rawRecapAmountReconciledTransaction').val());
        var amountRemaining = amountTransaction.minus(amountAlreadyReconciled).minus(amountToRec);
        $(recapDivSelector).find('#recapAmountRemaining').val(amountRemaining).change();
        $(recapDivSelector).find('#rawRecapAmountRemaining').val(amountRemaining);

    },

    /**
     * Accounting code reconciliation form
     */

    addAccountingLinkRow: function (selectedType) {
        var newIndice = parseFloat($('#recacc_nbAccLinks').val()) + 1;
        $('#recacc_nbAccLinks').val(newIndice);

        MyFacture.post(
            "bankreconciliation_transaction",
            {
                action: 'addRow',
                indice: newIndice,
                selectedType: selectedType,
            },
            function (data) {
                var newLine = $(data.bankreconciliation_accountingLinkRow);

                ($('div#accountingLinks')).append(newLine);
                //Init automatic format for amount field
                MyFacture.initEvent($('div.accountingLink:last-of-type'));
                //Init totals update

                $('.recacc_amount, .recacc_type').on('change', function () {
                    BankReconciliation.updateRecTotals('acc');
                }).change();



            }, "json"
        );
    },

    deleteAccountingLinkRow: function (elt) {
        elt.closest('div.accountingLink').remove();
        $('#recacc_nbAccLinks').val($('#recacc_nbAccLinks').val() - 1);
        BankReconciliation.updateRecTotals('acc');
    },

    deleteAccountingLink: function (transactionId, linkId) {
        MyFacture.startWait();
        var options = {
            'action': 'deleteAccountingLink',
            'transaction_id': transactionId,
            'id': linkId
        };

        var datas = MyFacture.post(
            'bankreconciliation_reconciliation',
            options,
            function (data) {
                if (data['status'] == 'ok') {
                    Utils.reload();
                } else {
                    Utils.relocate('./?_f=bankreconciliation_transactions');
                }

            }
        );
    },

    /**
     * Search form for documents
     */

    prepareSearchDocForm: function () {
        var formId = "searchForm";

        var options = {
            data: {
                action: 'searchDocuments',
                transactionId: $('#transactionId').val(),
            },
            beforeSubmit: function () {
                MyFacture.startWait();
            },
            success: function (data) {
                MyFacture.stopWait();

                var formIsOk = MyForm.processJson(data, formId);
                if (formIsOk) {
                    $("#resultSearchForm").html(data.detailsList);
                    MyFacture.initEvent("#resultSearchForm");
                    BankReconciliation.updateRecTotals('doc');
                }
            },
            dataType: "json"
        };

        MyForm.prepare(formId, "bankreconciliation_transaction", options);
    },


    /**
     * Bank accounts settings and synchronization
     */

    synchronize: function () {
        var self = this;
        var options = {
            resizable: false,
            noclose: true,
            title: self.translations.synchroTitle,
            type: "warning",
            buttons: [
                {
                    text:
                    self.translations.no,
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text:
                    self.translations.yes,
                    click: function () {
                        $.post('?_f=bankaccount&action=synchronize', function (reponse) {
                            if (reponse.status == 'success') {
                                Push.success(reponse.message)
                                $('#sync-btn').hide();
                            }
                            else{
                                Push.error(reponse.message)
                            }
                        }, 'json')
                        $(this).dialog("close");
                    }
                }
            ]
        };
        MyWindow.alert(self.translations.synchroContent, options);
    },

    /**
     * Reonciliation with documents
     */

    prepareReconciliateDocForm: function () {
        var self = this;
        var formId = '';

        if ($("#resultSearchForm").is(":visible")) {
            formId = 'resultSearchForm';
        }
        else if ($("#suggestionForm").is(":visible")) {
            formId = 'suggestionForm';
        }

        if (formId != '') {

            var options = {
                data: {
                    action: 'reconciliateDocument',
                    formId: formId,
                },
                beforeSubmit: function () {
                    MyFacture.startWait();
                },
                success: function (data) {

                    var formIsOk = MyForm.processJson(data, formId);
                    if (formIsOk) {

                        if (data.form.fields.reloadType == 'save') {
                            Utils.reload();
                        } else if (data.form.fields.reloadType == 'save_and_redirect') {
                            Utils.relocate('./?_f=bankreconciliation_transactions');
                        }

                    } else {
                        MyFacture.stopWait();
                        var msg = (data.form.msg !== undefined && data.form.msg != '') ? data.form.msg : self.translations.genericErrorMsg;
                        Push.error(msg);
                    }
                },
                dataType: "json"
            };

            MyForm.prepare(formId, "bankreconciliation_reconciliation", options);

            // Total recap dynamic update for each case (payment and deadline)
            $('div.newPayment').on('change', function () {
                BankReconciliation.updateRecTotals('doc');
            });
            BankReconciliation.updateRecTotals('doc');
        }

    },

    updateDocAmountField: function (element) {
        if (element.is(':checked')) {
            $(element).closest('div.newPayment').find('input.amountInput').removeAttr('disabled');
        } else {
            $(element).closest('div.newPayment').find('input.amountInput').attr('disabled', 'disabled');
        }
        BankReconciliation.updateRecTotals('doc');
    },

    deletePaymentLink: function (transaction_id, id, deletePayment) {
        MyFacture.startWait();
        var options = {
            'action': 'deletePaymentLink',
            'transaction_id': transaction_id,
            'id': id,
            'deletePayment': deletePayment,
        };

        var datas = MyFacture.post(
            'bankreconciliation_reconciliation',
            options,
            function (data) {
                if (data['status'] == 'ok') {
                    Utils.reload();
                } else {
                    Utils.relocate('./?_f=bankreconciliation_transactions');
                }
            }
        );
    },

    confirmQuickSuggestion: function (transaction_id) {
        MyFacture.startWait();
        var options = {
            'action': 'confirmQuickSuggestion',
            'transactionId': parseInt(transaction_id),
        };
        var datas = MyFacture.post(
            'bankreconciliation_reconciliation',
            options,
            function (data) {
                Listing.update('transactionsListing', false);
                MyFacture.stopWait();
            }
        );
    },

    updateTransactionType: function (el, transactionId, transactionType) {

        var self = this;

        var wording = $(el).closest('.dropdown').find('li.' + transactionType + '>a').text();

        var options = {
            'action': 'updateTransactionType',
            'updateTransactionType_transactionId': parseInt(transactionId),
            'updateTransactionType_transactionType': transactionType,
        };

        MyFacture.post(
            'bankreconciliation_transaction',
            options,
            function (data) {

                if (data.form.status == 'ok') {
                    $(el).closest('.dropdown').find('.transaction_type_wording').html(wording);
                    $(el).closest('.dropdown').find('li').show();
                    $(el).closest('.dropdown').find('li.' + transactionType).hide();
                } else {
                    MyFacture.stopWait();
                    var msg = (data.form.msg !== undefined && data.form.msg != '') ? data.form.msg : self.translations.genericErrorMsg;
                    Push.error(msg);
                }

            }
        );

    },

    redirectBudgetInsight: function () {

        MyFacture.startWait();
        var options = {
            'action': 'redirectBudgetInsight',
            'redirectPage': window.location.href.replace(window.location.origin, ""), // currentUrl whitout https://domain.com

        };
        var datas = MyFacture.post(
            'bankAccountPreferences',
            options,
            function (data) {
                Utils.relocate(data.link);
                return true;
            },
            "json"
        );
    },

    prepareTransferActionsTransactionForm: function () {

        var formId = 'transferFrom';
        var options = {
            data: {
                action: 'transferActionsTransaction',
                formId: formId,
            },
            beforeSubmit: function () {
                MyFacture.startWait();
                $('#transfer_recipient_transaction_id').val();
            },
            success: function (data) {

                var formIsOk = MyForm.processJson(data, formId);

                if (formIsOk) {
                    Utils.relocate('./?_f=bankreconciliation_transaction&action=view&id=' + $('#transfer_recipient_transaction_id').val());
                } else {
                    MyFacture.stopWait();
                    var msg = (data.form.msg !== undefined && data.form.msg != '') ? data.form.msg : self.translations.genericErrorMsg;
                    Push.error(msg);
                }

            },
            dataType: "json"
        };

        MyForm.prepare(formId, "bankreconciliation_transaction", options);

    },

    prepareCheckedTransactionEvent: function () {

        var self = this;

        // Declenche l'ouverture/fermeture du panneau en cas d'ajout/suppression d'une transaction
        $('.transaction_checkbox').unbind().prop('disabled', false).on('click', function () {

            var transaction_id = parseInt($(this).val());
            var bankaccount_id = parseInt($(this).data('bankaccountid'));

            if ($(this).is(':checked')) {
                // On ajoute a la liste des transactions
                self.addTransactionToMassAction(transaction_id, bankaccount_id);
            } else {
                // On le supprime de la liste des transaction
                self.removeTransactionFromMassAction(transaction_id, bankaccount_id);
            }

            self.updateMassActionForm();

        });
        $('.transaction_checkbox').prop('disabled', false);

        // Déclenche la coche/décoche de toute les transaction en cas de click sur la checkbox global
        $('#massTransactionChecker').unbind().on('click', function () {
            var isChecked = $(this).is(':checked');
            $('.transaction_checkbox').each(function () {

                var transaction_id = parseInt($(this).val());
                var bankaccount_id = parseInt($(this).data('bankaccountid'));

                if (isChecked) {
                    self.addTransactionToMassAction(transaction_id, bankaccount_id);
                    $(this).prop('checked', true);
                } else {
                    self.removeTransactionFromMassAction(transaction_id, bankaccount_id);
                    $(this).prop('checked', false);
                }

            });
        });
        $('#massTransactionChecker').prop('disabled', false);


        // Coche les checkbox qui sont déjà sélectionné
        $('.transaction_checkbox').each(function () {

            var transaction_id = parseInt($(this).val());
            var index = self.seletectedTransactions.indexOf(transaction_id);
            if (index > -1) {
                $(this).prop('checked', true);
            }


        });

        self.updateMassActionForm();
    },

    addTransactionToMassAction: function (transaction_id, bankAccountId) {

        // On ajoute la transaction dans le tableau 'seletectedTransactions'
        var index = this.seletectedTransactions.indexOf(transaction_id);
        if (index == -1) {
            this.seletectedTransactions.push(transaction_id);
            this.updateMassActionForm();
        }

        // On ajoute la transaction dans le tableau 'mapSelectedTransactionsByBankAccount'
        // On crée le tableau si il nexiste pas
        if (this.mapSelectedTransactionsByBankAccount[bankAccountId] === undefined) {
            this.mapSelectedTransactionsByBankAccount[bankAccountId] = [];
        }

        // On insert la transaction
        var index = this.mapSelectedTransactionsByBankAccount[bankAccountId].indexOf(transaction_id);
        if (index == -1) {
            this.mapSelectedTransactionsByBankAccount[bankAccountId].push(transaction_id);
        }


    },

    removeTransactionFromMassAction: function (transaction_id, bankAccountId) {

        // On supprime la transaction du 'seletectedTransactions'
        var index = this.seletectedTransactions.indexOf(transaction_id);
        if (index > -1) {
            $('#transaction_line_' + transaction_id).remove();
            this.seletectedTransactions.splice(index, 1);
            // We need to uncheck the checkbox IF checkbox exist and is check
            var checkBoxEl = $('input[name="checkbox_' + transaction_id + '"]');

            if (checkBoxEl.length) {

                // Si la checkbox est présente dans la page,
                // Nous décochons la massCheckbox
                $('#massTransactionChecker').prop('checked', false);

                // Et si la checbox est coché, alors on la décoche
                if (checkBoxEl.is(':checked')) {
                    checkBoxEl.prop('checked', false);
                }
            }


        }


        // On supprime transaction
        var index = this.mapSelectedTransactionsByBankAccount[bankAccountId].indexOf(transaction_id);
        if (index > -1) {
            this.mapSelectedTransactionsByBankAccount[bankAccountId].splice(index, 1);
        }
        this.updateMassActionForm();


    },

    removeAllTransactionsForBankAccountFromMassAction: function (bankAccountId) {

        var self = this;
        var transactionToDelete = [];

        for (var index in self.mapSelectedTransactionsByBankAccount[bankAccountId]) {
            var transaction_id = self.mapSelectedTransactionsByBankAccount[bankAccountId][index];
            transactionToDelete.push(transaction_id);
        }


        for (var index in transactionToDelete) {
            var transaction_id = transactionToDelete[index];
            self.removeTransactionFromMassAction(transaction_id, bankAccountId);
        }


    },

    updateMassActionForm: _.debounce(function () {

        if (this.seletectedTransactions.length) {
            var options = {
                'action': 'updateMassActionForm',
                'transactionIds': this.seletectedTransactions,
                'beforeSend': function () {

                }
            };

            var datas = MyFacture.post(
                'bankreconciliation_transactions',
                options,
                function (data) {
                    $('#massActionContainer').html(data.massActionContainer);
                }
            );
        } else {
            $('#massActionContainer').html('');
        }


    }, 800),

    displayMassActionPopup: function () {

        var self = this;

        var actionSelected = $('#transactionsMassAction_action').val();

        if (actionSelected != '') {

            var options = {
                dialogClass: "white no-title",
                buttons: [
                    {
                        text: self.translations.cancel, click: function () {
                            $(this).dialog("close");
                        }
                    },
                    {
                        text: self.translations.valid, click: function () {
                            $('#doTransactionMassActionForm').submit();
                            $(this).dialog("close");
                        }
                    }
                ],
                callback: function () {
                    MyFacture.initEvent('#doTransactionMassActionForm');
                    self.prepareMassAction();
                }
            };

            var param = {
                action: "displayMassActionPopup",
                transactionIds: this.seletectedTransactions,
                actionSelected: actionSelected,
            };

            MyWindow.load('bankreconciliation_transactions', param, options);
        }


    },

    prepareMassAction: function () {


        var self = this;

        var formId = 'doTransactionMassActionForm';

        var options = {
            data: {
                action: 'doMassAction',
                formId: formId,
                doMassActionForm_transactionIds: self.seletectedTransactions,
            },
            beforeSubmit: function () {
                MyFacture.startWait();
            },
            success: function (data) {

                var formIsOk = MyForm.processJson(data, formId);

                if (formIsOk) {
                    Listing.update('transactionsListing', false);
                    MyFacture.stopWait();

                    // On réinitilialise toute les variables
                    self.seletectedTransactions = [];
                    self.mapSelectedTransactionsByBankAccount = [];
                    self.updateMassActionForm();
                } else {
                    MyFacture.stopWait();
                    var msg = (data.form.msg !== undefined && data.form.msg != '') ? data.form.msg : self.translations.genericErrorMsg;
                    Push.error(msg);
                }


            },
            dataType: "json"
        };

        MyForm.prepare(formId, "bankreconciliation_transactions", options);
    },

    displayExportBankJournal : function(){


        var self = this;

        var options = {
            dialogClass: "no-title",
            resizable	: false,
            noclose		: false,
            title		: self.translations.exportBankJournal,
            callback 	: function () {
                self.prepareExportBankJournal();
            },
            buttons		: [
                {
                    text 	: self.translations.export,
                    'class'	: "btn btn-primary",
                    click 	: function() {
                        $('#exportBankJournal').submit();
                    }
                }
            ]
        };
        // MyWindow.alert(Loc.g("Voulez-vous supprimer les coordonnées bancaires ?"), options);

        var fileOpt = {
            action: "displayExportBankJournalModal",
            bankaccount_id : $('#transactionsListing_filter_bankAccountId').val()
        };
        MyWindow.load("bankreconciliation_transactions", fileOpt, options);

    },

    prepareExportBankJournal: function () {

        var self = this;

        var formId = 'exportBankJournal';

        var options = {
            data: {
                action: 'exportBankjournal',
                formId: formId,
            },
            beforeSubmit: function () {
                MyFacture.startWait();
            },
            success: function (data) {

                var formIsOk = MyForm.processJson(data, formId);

                if (formIsOk) {
                    MyFacture.stopWait();
                    MyWindow.close();
                    var title = self.translations.generatingExport;
                    var message = self.translations.exportMessaage;
                    Push.success(message, title)

                } else {
                    MyFacture.stopWait();
                    var msg = (data.form.msg !== undefined && data.form.msg != '') ? data.form.msg : self.translations.genericErrorMsg;
                    Push.error(msg);
                }


            },
            dataType: "json"
        };

        MyForm.prepare(formId, "bankreconciliation_transactions", options);
    },

    openTransferTransactionPanel: function() {
        window.sellsyapp.$store.state.popupPanel.transferTransactionForm.display = true;
    },

    initEventTransactionForm: function() {
        window.sellsyapp.$events.on('transaction:transfer:completed', () => Listing.update('transactionsListing'));
    }

}